// extracted by mini-css-extract-plugin
module.exports = {"root":"DataListItem_root__2I2L2"};